import React from 'react';
import Navbar from './Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import WhatsAppButton from './WhatsAppButton/WhatsAppButton';

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Layout; 